import { apiRequest } from '../../apiCall'

export const getInstruction= (params) => apiRequest('Instruction.GetInstruction',{},`?CustomerLineId=${params}`);
export const getCustomerNumber2= () => apiRequest('CustomerLine.GetCustomerLine');
export const saveInstruction= (params) => apiRequest('Instruction.SaveInstruction',params);
export const getCustomerMember= () => apiRequest('CustomerMember.GetCustomerMember');
